import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Login from './pages/Login';
import Register from './pages/Register';
import DemoSignup from './pages/DemoSignup';
import DemoBanner from './components/DemoBanner';
import Dashboard from './pages/Dashboard';
import InvestigationDetail from './pages/InvestigationDetail';
import FocusedGraphView from './pages/FocusedGraphView';
import DataSheetView from './pages/DataSheetView';
import KnownAddresses from './pages/KnownAddresses';
import TracePage from './pages/TracePage';
import Statements from './pages/Statements';
import IntakeFormPage from './pages/IntakeFormPage';
import AdminUsers from './pages/AdminUsers';
import './App.css';

function ProtectedRoute({ children }) {
  const token = useAuthStore((state) => state.token);
  if (!token) return <Navigate to="/login" />;
  return (
    <>
      <DemoBanner />
      {children}
    </>
  );
}

function ProtectedAdminRoute({ children }) {
  const token   = useAuthStore((state) => state.token);
  const role    = useAuthStore((state) => state.role);
  const isAdmin = useAuthStore((state) => state.isAdmin);
  if (!token) return <Navigate to="/login" />;
  if (role !== 'admin' && !isAdmin) return <Navigate to="/dashboard" />;
  return children;
}

function App() {
  const token = useAuthStore((state) => state.token);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/demo" element={<DemoSignup />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/investigation/:id"
          element={
            <ProtectedRoute>
              <InvestigationDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/investigation/:id/focused"
          element={
            <ProtectedRoute>
              <FocusedGraphView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/investigation/:id/datasheet"
          element={
            <ProtectedRoute>
              <DataSheetView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/known-addresses"
          element={
            <ProtectedRoute>
              <KnownAddresses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedAdminRoute>
              <AdminUsers />
            </ProtectedAdminRoute>
          }
        />
        <Route
          path="/trace/:blockchain/:address"
          element={
            <ProtectedRoute>
              <TracePage />
            </ProtectedRoute>
          }
        />
        {/* No ProtectedRoute: Statements opens in its own browser window and,
            per project decision, doesn't require login for this round. */}
        <Route path="/statements" element={<Statements />} />
        {/* No ProtectedRoute, deliberately: this is the client-facing intake
            form, shared via an unguessable token link -- see
            routers/intake_forms.py. The token itself is the credential. */}
        <Route path="/intake/:token" element={<IntakeFormPage />} />
        <Route 
          path="/" 
          element={token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} 
        />
      </Routes>
    </Router>
  );
}

export default App;
